// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2yxCQ","buttons":"Footer_buttons__1aZFO"};